module.exports = __webpack_public_path__ + "img/7.03d1aa7b.png";